import { SectionField } from "types/Models/Filing";
import { getLinkKey } from "./getLinkKey";
import { getModeKey } from "./getModeKey";
import { isUploadOrLinkMode } from "./isUploadOrLinkMode";

export const getUploadOrLinkSavedField = <T extends SectionField>(
  field: T,
  values: Record<string, unknown>
): T => {
  const documents = values[field.field_key];
  const link = values[getLinkKey(field.field_key)];
  const mode = values[getModeKey(field.field_key)];

  return {
    ...field,
    documents: Array.isArray(documents) ? documents : field.documents,
    link: typeof link === "string" ? link : field.link,
    mode: isUploadOrLinkMode(mode) ? mode : field.mode,
  };
};
